export const NAV_TOP = [
    { label: 'Start', path: '/start', icon: 'i-home' },
    { label: 'Suppliers', path: '/suppliers', icon: 'i-suppliers' },
];
export const NAV_SUBJECTS = [
    {
        subject: 'Strategy',
        modules: [
            { label: 'Maturity Assessment', path: '/maturity' },
            { label: 'Mega Trends', path: '/mega-trends' },
            { label: 'Procurement Strategy', path: '/procurement-strategy' },
            { label: 'Category Strategy', path: '/category-strategy' },
            { label: 'Category Intelligence', path: '/category-intelligence' },
            { label: 'Regulatory Watch', path: '/regulatory-watch' },
        ],
    },
    {
        subject: 'Spend Management',
        modules: [
            { label: 'Spend Overview', path: '/spend-overview' },
            { label: 'Tail Spend', path: '/tail-spend' },
            { label: 'Savings Pipeline', path: '/savings-pipeline' },
            { label: 'Payment Terms', path: '/payment-terms' },
        ],
    },
    {
        subject: 'Sourcing',
        modules: [
            { label: 'Sourcing Projects', path: '/sourcing' },
            { label: 'Lever Library', path: '/lever-library' },
        ],
    },
    {
        subject: 'Stakeholders',
        modules: [
            { label: 'Stakeholder Map', path: '/stakeholder-map' },
            { label: 'Business Reviews', path: '/business-reviews' },
        ],
    },
    {
        subject: 'Supplier Relationship',
        modules: [
            { label: 'Kraljic Segmentation', path: '/kraljic' },
            { label: 'Performance Scorecard', path: '/scorecard' },
            { label: 'Supplier Innovation', path: '/supplier-innovation', soon: true },
        ],
    },
    {
        subject: 'Contract',
        modules: [
            { label: 'Repository', path: '/contract-repository' },
            { label: 'Expiry Calendar', path: '/expiry-calendar' },
            { label: 'Contract Templates', path: '/contract-templates' },
        ],
    },
    {
        subject: 'Risk',
        modules: [
            { label: 'Security of Supply', path: '/security-of-supply' },
            { label: 'Supplier News', path: '/supplier-news' },
            { label: 'ESG Scorecard', path: '/esg-scorecard' },
            { label: 'Financial Health', path: '/financial-health' },
        ],
    },
    {
        subject: 'Governance',
        modules: [
            { label: 'Policy Builder', path: '/policy-builder' },
            { label: 'Chart of Authority', path: '/chart-of-authority' },
        ],
    },
    {
        subject: 'Impact',
        modules: [
            { label: 'Reporting Dashboard', path: '/reporting' },
            { label: 'Target Board', path: '/target-board' },
        ],
    },
];
export const SETTINGS = { label: 'Settings', path: '/settings' };
/**
 * Settings sections (D-103): Files and Master Data live under Settings, not in the Column 1 nav.
 * Listed here so each gets a route and a "Settings · <section>" breadcrumb without appearing in the
 * subject navigation. Master Data is the first built section (D-100/D-101); others follow as designed.
 */
export const SETTINGS_SECTIONS = [
    { label: 'Master Data', path: '/master-data' },
    { label: 'Your accepted terms', path: '/settings/terms' },
    { label: 'Profile & Security', path: '/settings/profile' },
    { label: 'Members', path: '/settings/members' },
    { label: 'Organisation', path: '/settings/organisation' },
    { label: 'Audit Log', path: '/settings/audit' },
];
export const NAV_ENTRIES = [
    ...NAV_TOP.map((t) => ({ label: t.label, path: t.path, subject: '', locked: false, soon: false })),
    ...NAV_SUBJECTS.flatMap((s) => s.modules.map((m) => ({
        label: m.label,
        path: m.path,
        subject: s.subject,
        locked: Boolean(m.locked),
        soon: Boolean(m.soon),
    }))),
    // The onboarding workbook flow (D-155b): reached from the Start page's third path, not from Column 1.
    { label: 'Start with your own data', path: '/import', subject: 'Start', locked: false, soon: false },
    { label: SETTINGS.label, path: SETTINGS.path, subject: 'Settings', locked: false, soon: false },
    ...SETTINGS_SECTIONS.map((m) => ({ label: m.label, path: m.path, subject: 'Settings', locked: false, soon: false })),
];
export const DEFAULT_PATH = '/start';
export function navEntryFor(path) {
    return NAV_ENTRIES.find((e) => e.path === path);
}
//# sourceMappingURL=nav.js.map